/**
 * @file ElementWarningNote.tsx
 * @description Предупреждение об элементе под самим полем (phase19.16,
 * партия SB120, этап 3б; uiux-sb120-stage3 §7 — «предупреждения, не
 * запреты»): предупреждения shared `sectionElementWarnings` ровно по пути
 * поля («7–8 в ряд», «светлый текст без затемнения», «смена быстрее 5 с»,
 * контраст к фону шапки и полос таблицы) — жёлтой полосой. Сохранить и
 * опубликовать можно; те же строки — в списке замечаний секции.
 */

import { NoticeStrip } from "../../../ui/NoticeStrip";
import { useSectionForm } from "../section-form-context";
import { elementWarningText, elementWarningsAt } from "../../../../lib/site-builder/element-warnings";

interface Props {
  /** Полный путь поля: `columns.items.0.elements.2.cols`. */
  path: string;
}

export function ElementWarningNote({ path }: Props) {
  const found = elementWarningsAt(useSectionForm().elementWarnings, path);
  if (found.length === 0) return null;
  return (
    <>
      {found.map((w) => (
        <NoticeStrip key={w.code} tone="warning">
          {elementWarningText(w)}
        </NoticeStrip>
      ))}
    </>
  );
}
